<template>
  <el-dialog
    :visible="showViewAddrNode"
    :show-close="true"
    fullscreen
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="80%">
    <el-row>
      <el-col :span="10">
        <el-page-header @back="handleClose()" content="butelproxy" title="返回"
                        style="margin-top: -10px;margin-bottom: 10px;">
        </el-page-header>
      </el-col>
      <el-col :span="10">
        <el-tag type="info">灰色节点:可代理地址组</el-tag>
        <el-tag type="success">绿色节点:本网络平面</el-tag>
        <el-tag type="danger">红色节点:不可用</el-tag>
      </el-col>
    </el-row>
    <el-tabs v-model="tabsName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :key="item.name+''"
        v-for="(item, index) in addrGroupList"
        :label="item.name +''"
        :name="item.name+''"
      >
        <div :id="'containerNode_'+index" :style="{height:mapHeight +'px'}"></div>
      </el-tab-pane>
      <el-tab-pane label="网络平面" name="netPlane">
        <canvas id="canvas" height="500" width="1300"></canvas>
      </el-tab-pane>

    </el-tabs>

  </el-dialog>
</template>

<script>
import * as echarts from 'echarts'
import {mapState} from 'vuex';

export default {
  name: "AddrNode",
  data() {
    return {
      myChart: null,
      mapHeight: 480,
      tabsName: "",
      nodeData: null,
      jTopoData: null,
      nodeLinks: [],
      count: 1,
      r: 30
    }
  },
  computed: {
    ...mapState('main', ['tableHeight'])
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name == "netPlane") {

      } else {
        let _this = this;
        for (let i = 0; i < _this.addrGroupList.length; i++) {
          if (_this.tabsName == _this.addrGroupList[i].name) {
            _this.nodeData = _this.addrGroupList[i]
          }
        }

        _this.initMap(tab.index);
        _this.$nextTick(() => {
          _this.$forceUpdate();
        })
      }
    },
    handleClose() {
      this.$emit('editCallback', null)
    },
    child(param) {
      let _this = this;
      if (param && param.length > 0) {
        param.forEach(e => {
          if (_this.selectedNodeId == e.proxyNode) {
            e.symbolSize = 18
          }
          // proxyNode
          if (_this.viewNetPlaneItme.id == e.netPlaneId) {
            e.itemStyle = {
              color: "green"
            };
          }
          if (!e.available) {
            e.itemStyle = {
              color: "red"
            };
          }
          if (e.children && e.children.length > 0) {
            _this.child(e.children)
          }
        })
      }
    },
    conventNatType(type) {
      if (type == 0) {
        return "无映射"
      } else if (type == 1) {
        return "NAT"
      } else if (type == 2) {
        return "ButelProxy"
      } else if (type == 3) {
        return "Nginx"
      } else {
        return "未知类型"
      }
    },
    initMap(idx) {
      let _this = this;
      let chartDom = document.getElementById('containerNode_' + idx);
      _this.myChart = null;
      _this.myChart = echarts.init(chartDom)
      let data = this.nodeData;

      if (data) {
        if (_this.selectedNodeId == data.proxyNode) {
          data.symbolSize = 18
        }
        if (_this.viewNetPlaneItme.id == data.netPlaneId) {
          data.itemStyle = {
            color: "green"
          };
        }
        if (!data.available) {
          data.itemStyle = {
            color: "red"
          };
        }
        if (data.children && data.children.length > 0) {
          _this.child(data.children)
        }
      }
      let option = {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          formatter: function (param) {
            return '地址组Id:' + param.data.id + '<br/>' + '网络平面ID:' + param.data.netPlaneId + '<br/>' + '网络平面:' + param.data.netPlaneName +
              '<br/>' + '地域信息:' + param.data.domainName + '<br/>' + 'IDC:' + param.data.idcName + '<br/>' + '设备名称:' + param.data.deviceName
              + '<br/>' + '映射类型:' + _this.conventNatType(param.data.natType) + (param.data.proxyNode != 0 ? '<br/>' + '代理Node:' + param.data.proxyNode : '')
          }
        },
        series: [
          {
            type: 'tree',
            name: this.tabsName,
            data: [data],
            top: '5%',
            left: '7%',
            bottom: '2%',
            right: '20%',
            symbol: 'circle',//设置为实心圆点
            symbolSize: 13,
            label: {
              position: 'left',
              verticalAlign: 'middle',
              align: 'right'
            },
            leaves: {
              label: {
                position: 'right',
                verticalAlign: 'middle',
                align: 'left'
              }
            },
            emphasis: {
              focus: 'descendant'
            },
            expandAndCollapse: false,
            animationDuration: 550,
            animationDurationUpdate: 750
          }
        ]
      };

      this.myChart.setOption(option);
      this.myChart.on("click", this.clickFun);

      _this.$nextTick(() => {
        _this.$forceUpdate();
        _this.myChart.resize();
      })
    },
    clickFun(param) {
      if (typeof param.seriesIndex == 'undefined') {
        return;
      }
      if (param.data.proxyNode == this.selectedNodeId) {
        this.$message.warning("当前节点不可选择(不可代理自身)！")
        return;
      }
      let _this = this;
      if (param.type == 'click') {
        if (!param.data.available) {
          _this.$message({showClose: true, message: '没有可访问性', type: 'warning'})
          return;
        }
        let item = {
          param: param,
          selectIdx: this.selectIdx,
        }
        this.$emit('editCallback', item)
      }
    },
    handleChildData(data, scene, node, map) {
      let _this = this;
      for (let j = 0; j < data.length; j++) {
        let obj = data[j]
        let vmNode = null
        if (obj.type == 1) {
          vmNode = new JTopo.CircleNode(obj.netPlaneName);
          vmNode.fillColor = '200,255,12';
          vmNode.radius = 25;
        } else {
          vmNode = new JTopo.Node(obj.netPlaneName);
          //vmNode.fillColor = '47,227,5';
          let color = map.get(obj.id)
          if (color) {
            vmNode.fillColor = color;
          } else {
            color = _this.randomRgb()
            map.set(obj.id, color)
            vmNode.fillColor = color;
          }
          vmNode.radius = 15;
        }
        vmNode.fontColor = '1,43,21';
        vmNode.setLocation(scene.width * Math.random(), scene.height * Math.random());
        vmNode.layout = {type: 'tree', direction: 'right', width: 50, height: 100};
        scene.add(vmNode);
        let link = new JTopo.Link(node, vmNode)
        link.arrowsRadius = 10;
        scene.add(link);
        if (obj.accessNetPlaneList && obj.accessNetPlaneList.length > 0) {
          _this.handleChildData(obj.accessNetPlaneList, scene, vmNode, map);
        }
      }
    },
    initJTopo() {
      let _this = this;
      let canvas = document.getElementById('canvas');
      let stage = new JTopo.Stage(canvas);
      let scene = new JTopo.Scene();
      stage.add(scene);
      let cloudNode = null;
      cloudNode = new JTopo.Node(this.viewNetPlaneItme.netPlaneName);
      cloudNode.setSize(30, 26);
      cloudNode.setLocation(100, 100);
      cloudNode.fontColor = '1,43,21';
      cloudNode.fillColor = '193,200,3';
      cloudNode.layout = {type: 'tree', direction: 'right', width: 180, height: 100}
      scene.add(cloudNode);
      if (!_this.jTopoData || _this.jTopoData.length == 0) {
        cloudNode.setLocation(20, 50);
        return
      }
      let map = new Map();
      for (let i = 0; i < _this.jTopoData.length; i++) {
        let obj = _this.jTopoData[i];
        let node = null;
        if (obj.type == 1) {
          node = new JTopo.CircleNode(obj.netPlaneName);
          node.fillColor = '200,255,12';//绿色
          node.radius = 25;
        } else {
          node = new JTopo.Node(obj.netPlaneName);
          let color = map.get(obj.id);
          if (color) {
            node.fillColor = color;
          } else {
            color = _this.randomRgb();
            map.set(obj.id, color);
            node.fillColor = color;
          }
          node.radius = 15;
        }
        node.fontColor = '1,43,21'
        node.setLocation(scene.width * Math.random(), scene.height * Math.random());
        node.layout = {type: 'tree', direction: 'right', width: 50, height: 100};
        scene.add(node);
        let link = new JTopo.Link(cloudNode, node);
        link.arrowsRadius = 10;
        scene.add(link);
        if (obj.accessNetPlaneList && obj.accessNetPlaneList.length > 0) {
          _this.handleChildData(obj.accessNetPlaneList, scene, node, map);
        }
      }
      stage.centerAndZoom(0);
      JTopo.layout.layoutNode(scene, cloudNode, true);
      scene.addEventListener('mouseup', function (e) {
        if (e.target && e.target.layout) {
          JTopo.layout.layoutNode(scene, e.target, true);
        }
      });
    },
    randomRgb() {
      const R = Math.floor(Math.random() * 155);
      const G = Math.floor(Math.random() * 255);
      const B = Math.floor(Math.random() * 155);
      return R + ',' + G + ',' + B
    },
    initData() {
      var data = {
        'id': this.viewNetPlaneItme.id
      };
      var _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/netplane/netplaneaccesslist', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.jTopoData = data;
            this.$nextTick(() => {
              _this.initJTopo()
            })
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
  created() {
    if (this.addrGroupList.length > 0) {
      this.tabsName = this.addrGroupList[0].name + "";
      this.nodeData = this.addrGroupList[0];
    }
  },
  mounted() {
    this.mapHeight = this.tableHeight ? this.tableHeight : 480;
    this.$nextTick(() => {
      if (this.addrGroupList.length > 0) {
        this.initMap(0);
      }
    });
    this.initData();
  },
  props: {
    selectedNodeId: {
      type: Number
    },
    showViewAddrNode: {
      type: Boolean
    },
    addrGroupList: {
      type: Array
    },
    selectIdx: {
      type: Number
    },
    viewNetPlaneItme: {
      type: Object
    }
  },
}
</script>

<style scoped>
.el-dialog__body {
  padding: 0px !important;
  background-color: #c1c803;
}
</style>
